import WavesChart from "./waves-chart/waves-chart";
import { useDispatch } from "react-redux";
import { AppDispatch, useSelector } from "@/core/redux/store";
import { useEffect, useMemo } from "react";
import { getSpecificationItemSources } from "@/core/redux/thunks/dashboardThunk";
import { Skeleton } from "@/shared/components/ui/skeleton";

export default function SpecItemSources() {
  const dispatch = useDispatch<AppDispatch>();
  const isLoading = useSelector((state) => state.dashboard.loadingSpecificationItemSources);
  const company = useSelector((state) => state.user.me?.company);
  const specificationItemSources = useSelector((state) => state.dashboard.specificationItemSources);
  const filterParams = useSelector((state) => state.dashboard.filterParams);
  useEffect(() => {
    if (!company?.id) return;
    dispatch(getSpecificationItemSources({ companyId: company.id, ...filterParams }));
  }, [company?.id, filterParams]);
  const topSpecItemSources = useMemo(() => {
    const analyzedProduct = specificationItemSources?.find((item) => item.itemSource === "analyzedProduct");
    const allItem = specificationItemSources?.find((item) => item.itemSource === "allItem");
    return {
      analyzedProduct: analyzedProduct?.count ?? 0,
      allItem: allItem?.count ?? 0,
    };
  }, [specificationItemSources]);
  const wavesChartData = useMemo(() => {
    return specificationItemSources?.filter((item) => item.itemSource !== "analyzedProduct" && item.itemSource !== "allItem").map((item) => ({
      itemSource: item.itemSource,
      value: item.count,
    })) ?? [];
  }, [specificationItemSources]);
  return (
    <div className="w-full flex flex-col border border-[#e5e5e5] bg-white rounded-[16px] h-[399px] overflow-hidden">
      <div className="border-b border-[#e4e4e7] h-[50px] flex items-center px-[20px] py-[16px]">
        <div className="flex items-start flex-1 h-full">
          <p className="text-[16px] font-[700] text-[#000000] leading-[24px]">
            Şartname Madde Kaynakları
          </p>
        </div>
      </div>
      <div className="flex flex-shrink-0 h-[96px]">
        <div className="flex-1 px-[20px] pt-[16px] ">
          <div className="flex flex-col border-r border-[#e4e4e7]">
            <div className="text-[12px] text-muted-foreground font-600">
              Analiz Edilen Ürün
            </div>
            <div className="font-[Inter] font-[700] text-[36px] text-black leading-[43px]">
              {isLoading ? <Skeleton className="w-[60px] h-[30px] mt-[10px]" /> : topSpecItemSources.analyzedProduct}
            </div>
          </div>
        </div>
        <div className="flex-1 px-[20px] pt-[16px] ">
          <div className="flex flex-col ">
            <div className="text-[12px] text-muted-foreground font-600">
              Toplam Madde
            </div>
            <div className="font-[Inter] font-[700] text-[36px] text-black leading-[43px]">
              {isLoading ? <Skeleton className="w-[60px] h-[30px] mt-[10px]" /> : topSpecItemSources.allItem}
            </div>
          </div>
        </div>
      </div>
      <WavesChart data={wavesChartData} />
    </div>
  );
}
